export const DIGIT = /^[0-9]$/;
export const DIGIT_SYMBOL = {
    value: '0',
    match: DIGIT.test.bind(DIGIT),
};

export const LETTER = /^[a-zA-Z]$/;
export const LETTER_SYMBOL = {
    value: 'a',
    match: LETTER.test.bind(LETTER),
};

export const DEFAULT_MATCHABLE_SYMBOLS = [DIGIT_SYMBOL, LETTER_SYMBOL];
